module.exports = require('./helpers/bundle-url').getBundleURL('43Ydi') + "logo-dark.ba5147f0.svg";